import { Skeleton } from '@mui/material';
import { FC } from 'react';
import { randomBetween } from '../../../patient-profile-widget/utils/random-between';
import { LabeledSectionSkeleton } from '../labeled-section/labeled-section.skeleton';

export const PmsStatusSectionSkeleton: FC = () => (
  <LabeledSectionSkeleton labelWidth={randomBetween(70, 100)}>
    <Skeleton variant="rounded" width={60} height={18} />
  </LabeledSectionSkeleton>
);
